"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _styles = require("@mui/material/styles");
var _HelpOutline = _interopRequireDefault(require("@mui/icons-material/HelpOutline"));
var _labelConsts = require("../../constants/labelConsts");
var _CDialog = _interopRequireDefault(require("../materials/CDialog"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const StyledIconButton = (0, _styles.styled)(_IconButton.default)({
  display: 'flex'
});
const StyledInfoIcon = (0, _styles.styled)(_HelpOutline.default)({
  color: '#FFFFFF'
});
const StyledDialogContent = (0, _styles.styled)(_DialogContent.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    padding: theme.spacing(1)
  };
});

/**
 * タイトル横のヘルプアイコン
 * @prop {string | node} help - ヘルプ表示内容
 * @prop {number} width - ヘルプダイアログの最大横幅
 */
class TitleHelpMark extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "openHelp", e => {
      if (e && e.currentTarget && typeof e.currentTarget.blur === 'function') {
        e.currentTarget.blur();
      }
      this.setState({
        isHelpOpen: true
      });
    });
    _defineProperty(this, "closeHelp", () => {
      this.setState({
        isHelpOpen: false
      });
    });
    this.state = {
      isHelpOpen: false
    };
  }
  render() {
    const {
      className,
      help,
      intl
    } = this.props;
    const {
      isHelpOpen
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledIconButton, {
      className: className,
      onClick: this.openHelp,
      disableRipple: true,
      disableFocusRipple: true,
      "aria-label": intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HELP
      })
    }, /*#__PURE__*/_react.default.createElement(StyledInfoIcon, null)), /*#__PURE__*/_react.default.createElement(_CDialog.default, {
      maxWidth: "sm",
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HELP
      }),
      open: isHelpOpen,
      handleClose: this.closeHelp
    }, /*#__PURE__*/_react.default.createElement(StyledDialogContent, {
      sx: {
        marginTop: 1
      }
    }, help)));
  }
}
TitleHelpMark.propTypes = {
  help: _propTypes.default.node
};
var _default = exports.default = (0, _reactIntl.injectIntl)(TitleHelpMark);